<form #form="ngForm" class="container-form-sc" novalidate (submit)="onSave()" *ngIf="isOpen">
    <!--Options-->
    <div class="row container-form-sc-options">
        <div class="col-12">
            <button type="submit" class="btn btn-link btn-link-success">
                <i class="fas fa-check" aria-hidden="true"></i> Salvar
            </button>
              <button type="button" class="btn btn-link" (click)="onCancel()">
                <i class="fas fa-undo" aria-hidden="true"></i> Cancelar
            </button>
        </div>
    </div>

    <!--Content-->
    <div class="row container-form-sc-content" *ngIf="entity">
        <div class="col-12">
            <div class="row">
                <div class="form-group col-12 col-md-3">
                    <label for="enderecoCep" class="col-form-label">CEP</label>
                    <input type="text" class="form-control" [(ngModel)]="entity.cep" name="enderecoCep" id="enderecoCep"
                        #enderecoCep="ngModel" required="required" maxlength="20" [autofocus]="true">
                    <sgt-form-control-error
                        *ngIf="enderecoCep.errors && enderecoCep.errors.required && enderecoCep.dirty"
                        msgError="O CEP é obrigatório">
                    </sgt-form-control-error>
                    <sgt-form-control-error
                        *ngIf="enderecoCep.errors && enderecoCep.errors.maxlength"
                        msgError="O CEP deve ter no máximo 20 caracteres">
                    </sgt-form-control-error>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-12">
                     <label for="enderecoLogradouro" class="col-form-label">Logradouro</label>
                     <input type="text" class="form-control" [(ngModel)]="entity.logradouro" name="enderecoLogradouro" id="enderecoLogradouro"
                        #enderecoLogradouro="ngModel" required="required" maxlength="255" sgtUppercase>
                    <sgt-form-control-error
                        *ngIf="enderecoLogradouro.errors && enderecoLogradouro.errors.required && enderecoLogradouro.dirty"
                        msgError="O logradouro é obrigatório">
                    </sgt-form-control-error>
                    <sgt-form-control-error
                        *ngIf="enderecoLogradouro.errors && enderecoLogradouro.errors.maxlength"
                        msgError="O logradouro deve ter no máximo 255 caracteres">
                    </sgt-form-control-error>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-12 col-md-3">
                    <label for="enderecoNumero" class="col-form-label">Número</label>
                    <input type="text" class="form-control" [(ngModel)]="entity.numero" name="enderecoNumero" id="enderecoNumero"
                        #enderecoNumero="ngModel" maxlength="20" sgtUppercase>
                    <sgt-form-control-error
                        *ngIf="enderecoNumero.errors && enderecoNumero.errors.maxlength"
                        msgError="O número deve ter no máximo 20 caracteres">
                    </sgt-form-control-error>
                </div>
                <div class="form-group col-12 col-md-9">
                    <label for="enderecoBairro" class="col-form-label">Bairro</label>
                    <input type="text" class="form-control" [(ngModel)]="entity.bairro" name="enderecoBairro" id="enderecoBairro"
                        #enderecoBairro="ngModel" maxlength="255" sgtUppercase>
                    <sgt-form-control-error
                        *ngIf="enderecoBairro.errors && enderecoBairro.errors.maxlength"
                        msgError="O bairro deve ter no máximo 255 caracteres">
                    </sgt-form-control-error>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-12">
                    <label for="enderecoComplemento" class="col-form-label">Complemento</label>
                    <input type="text" class="form-control" [(ngModel)]="entity.complemento" name="enderecoComplemento" id="enderecoComplemento"
                        #enderecoComplemento="ngModel" maxlength="255" sgtUppercase>
                    <sgt-form-control-error
                        *ngIf="enderecoComplemento.errors && enderecoComplemento.errors.maxlength"
                        msgError="O complemento deve ter no máximo 255 caracteres">
                    </sgt-form-control-error>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-12">
                    <label for="enderecoCidade" class="col-form-label">Cidade</label>
                    <select class="form-control" name="enderecoCidade" id="enderecoCidade"
                        [ngModel]="entity.idCidade || ''" (ngModelChange)="entity.idCidade = $event ? $event : null"
                        #enderecoCidade="ngModel" required="required">
                        <option value="">Selecione a cidade...</option>
                        <option *ngFor="let cidade of cidades" [ngValue]="cidade.id">{{cidade.nome}}</option>
                    </select>
                    <sgt-form-control-error
                        *ngIf="enderecoCidade.errors && enderecoCidade.errors.required && enderecoCidade.dirty"
                        msgError="A cidade é obrigatória">
                    </sgt-form-control-error>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-12 col-md-6">
                    <label for="enderecoInscMunicipal" class="col-form-label">Inscrição Municipal</label>
                    <input type="text" class="form-control" [(ngModel)]="entity.inscricaoMunicipal" name="enderecoInscMunicipal" id="enderecoInscMunicipal"
                        #enderecoInscMunicipal="ngModel" maxlength="20">
                    <sgt-form-control-error
                        *ngIf="enderecoInscMunicipal.errors && enderecoInscMunicipal.errors.maxlength"
                        msgError="A inscrição municipal deve ter no máximo 20 caracteres">
                    </sgt-form-control-error>
                </div>
                <div class="form-group col-12 col-md-6">
                    <label for="enderecoInscEstadual" class="col-form-label">Inscrição Estadual</label>
                    <input type="text" class="form-control" [(ngModel)]="entity.inscricaoEstadual" name="enderecoInscEstadual" id="enderecoInscEstadual"
                        #enderecoInscEstadual="ngModel" maxlength="20">
                    <sgt-form-control-error
                        *ngIf="enderecoInscEstadual.errors && enderecoInscEstadual.errors.maxlength"
                        msgError="A inscrição estadual deve ter no máximo 20 caracteres">
                    </sgt-form-control-error>
                </div>
            </div>
        </div>
    </div>
</form>
